import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadComponent } from 'components/file-upload/file-upload.component';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import {
  FILE_OBJECT_TYPE_INFO_REQUEST_INVOICE,
  type InformationRequestInvoiceListByInformationRequestIdItem
} from 'types/information-request.interface';

@Component({
  selector: 'app-ir-invoice-send-portal-modal',
  standalone: true,
  imports: [TranslateModule, FileUploadComponent, TooltipComponent],
  templateUrl: './send-portal-modal.component.html'
})
export class IrInvoiceSendPortalModalComponent implements OnChanges {
  readonly fileTypeInvoice = FILE_OBJECT_TYPE_INFO_REQUEST_INVOICE;
  @Input() isOpen = false;
  @Input() invoice: InformationRequestInvoiceListByInformationRequestIdItem | null = null;
  @Input() isLoading = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  @ViewChild('content') content!: TemplateRef<unknown>;

  constructor(private modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isOpen']) return;
    if (this.isOpen) {
      this.modalService.open(this.content, { backdrop: 'static', keyboard: false, windowClass: 'start-processing-modal' });
    } else {
      this.modalService.dismissAll();
    }
  }

  confirm(): void {
    if (this.isLoading) return;
    this.confirmed.emit();
  }

  close(): void {
    this.modalService.dismissAll();
    this.closed.emit();
  }
}
